import { useState } from 'react';
import ConfirmModal from 'components/confirm-modal';
import { lowerCase } from 'lodash';
import {
  ActivityFeedDraftTypeEnum,
  ActivityFeedStatusEnum,
  TActivityFeedDraftItem,
  useDeleteCommentMutation,
  useDeletePostMutation,
} from 'redux-store/api/activity-feed';

interface IDraftDeletionConfirmDialog {
  draft: TActivityFeedDraftItem;
  onClose: () => void;
}

export const DraftDeletionConfirmDialog = ({ draft, onClose }: IDraftDeletionConfirmDialog) => {
  const [isLoading, setIsLoading] = useState(false);

  const [deleteComment] = useDeleteCommentMutation();
  const [deletePost] = useDeletePostMutation();

  const onDelete = (draftToBeDeleted: TActivityFeedDraftItem) => {
    const { id, projectId, data } = draftToBeDeleted;
    const commonParams = { projectId, status: ActivityFeedStatusEnum.DRAFT };

    setIsLoading(true);

    const request =
      draftToBeDeleted.type === ActivityFeedDraftTypeEnum.POST
        ? deletePost({ ...commonParams, ids: [id] })
        : deleteComment({
            ...commonParams,
            ids: [data.id],
            postId: draftToBeDeleted.data.postId,
            rootCommentId: draftToBeDeleted.data.rootCommentId,
          });

    request.unwrap().finally(() => {
      onClose();
      setIsLoading(false);
    });
  };

  return (
    <ConfirmModal
      open
      isLoading={isLoading}
      title=""
      text={`Are you sure you would like to discard this ${lowerCase(draft.type)}?`}
      confirmText="Confirm"
      onConfirm={() => onDelete(draft)}
      onClose={isLoading ? () => {} : onClose}
    />
  );
};
